import _defineProperty from "/home/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Box, Button } from '@miro-site/core';
import TransparentButton from '../../button/TransparentButton';
import SecondaryLink from '../../link/SecondaryLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ActionsOverlayBase = function ActionsOverlayBase(_ref) {
  var metadataId = _ref.metadataId,
      templateActions = _ref.templateActions,
      templatePagePath = _ref.templatePagePath,
      className = _ref.className,
      onMoreInfoClick = _ref.onMoreInfoClick,
      previewButton = _ref.previewButton,
      actionButtonProps = _ref.actionButtonProps,
      isVisible = _ref.isVisible;

  var defaultPreviewButton = /*#__PURE__*/_jsx(TransparentButton, {
    $size: "small",
    href: templatePagePath,
    onFocus: function onFocus() {
      return setOverlayVisible(true);
    },
    onBlur: function onBlur() {
      return setOverlayVisible(false);
    },
    children: templateActions.PREVIEW
  });

  var _useState = useState(isVisible),
      isOverlayVisible = _useState[0],
      setOverlayVisible = _useState[1];

  useEffect(function () {
    setOverlayVisible(isVisible);
  }, [isVisible]);
  return /*#__PURE__*/_jsx(Box, {
    "data-track-place": "actions-overlay",
    className: className,
    $styles: {
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: 2,
      background: 'primaryWhite',
      borderRadius: [8, 16, 16, 16],
      transition: 'opacity 250ms, visibility 250ms',
      opacity: isOverlayVisible ? 1 : 0,
      pointerEvents: isOverlayVisible ? 'all' : 'none'
    },
    children: /*#__PURE__*/_jsxs(Box, {
      $styles: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
      },
      children: [actionButtonProps ? /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        "data-track-id": "use-template",
        "data-template-id": metadataId,
        $buttonType: "primary",
        $size: "small",
        $mr: 12,
        onFocus: function onFocus() {
          return setOverlayVisible(true);
        },
        onBlur: function onBlur() {
          return setOverlayVisible(false);
        }
      }, actionButtonProps), {}, {
        children: actionButtonProps.children || templateActions.USE_TEMPLATE
      })) : null, previewButton ? previewButton(defaultPreviewButton) : defaultPreviewButton, /*#__PURE__*/_jsx(SecondaryLink, {
        $isDashed: true,
        onClick: onMoreInfoClick,
        $styles: {
          position: 'absolute',
          right: 20,
          bottom: 25
        },
        "data-testid": "more-info-button",
        onFocus: function onFocus() {
          return setOverlayVisible(true);
        },
        onBlur: function onBlur() {
          return setOverlayVisible(false);
        },
        children: templateActions.SHOW_MORE_INFO
      })]
    })
  });
};

var ActionsOverlay = styled(ActionsOverlayBase).withConfig({
  displayName: "ActionsOverlay",
  componentId: "sc-xdl9ce-0"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["background:rgba(var(--wcds-colors-white-rgb),0.95);border:1px solid ", ";box-shadow:", ";"], theme.colors.grey, theme.templates.elevation.overlay);
});
export default ActionsOverlay;